/* eslint-disable no-undef */

// Webpack emits one chunk per component here and fetches only the ones a page
// actually mounts. An eager context instead bundles the whole directory — every
// backoffice screen, wizard step and component stylesheet — into the pack that
// loads on every page.
const componentContext = require.context(
  'components',
  true,
  /^(?!.*\.test\.).*\.(jsx?|tsx?)$/,
  'lazy'
);

// Components are mounted by a path with no file extension ("jobList/JobList"),
// but a context only answers to extensionless requests when its filter matches
// them as well. Map those requests onto the real module paths rather than
// widening the filter to every file under `components/`.
const modulePaths = componentContext.keys().reduce((paths, key) => {
  paths[key.replace(/\.[jt]sx?$/, '')] = key;

  return paths;
}, {});

const constructors = {};

// Same resolution react_ujs does: "pages/show.Body" loads `pages/show`, then
// walks into its named exports.
function constructorFrom(module, keys) {
  const component = keys.reduce((value, key) => value[key], module);

  return component && component.__esModule ? component.default : component;
}

function load(className) {
  const [path, ...keys] = className.split('.');
  const modulePath = modulePaths[`./${path}`];

  // Unknown names are left to react_ujs, which reports them when it mounts.
  if (!modulePath) return Promise.resolve(undefined);

  return componentContext(modulePath).then(
    module => constructorFrom(module, keys),
    error => {
      // A chunk that fails to download would otherwise be indistinguishable
      // from a component that does not exist.
      console.error(error); // eslint-disable-line no-console

      return undefined;
    }
  );
}

export function pendingConstructors(classNames) {
  return classNames.filter(
    (className, index) => !(className in constructors) && classNames.indexOf(className) === index
  );
}

export function loadConstructors(classNames) {
  return Promise.all(
    classNames.map(className =>
      load(className).then(component => {
        // Only successes are kept, so a chunk lost to a network blip is
        // retried the next time the component is mounted.
        if (component) constructors[className] = component;
      })
    )
  );
}

// react_ujs mounts synchronously, so it can only read constructors that
// `loadConstructors` has already resolved.
export function loadedConstructor(className) {
  return constructors[className];
}
